// Drag-the-route rerouting: the pure decisions behind it, no DOM. Points are
// in canvas pixels, so hit distances feel the same on any scope size.

/** Pointer travel (px) before a press on a hub end counts as a drag, not a click. */
export const DRAG_THRESHOLD = 6;

/** Index of the hub nearest `point` within `maxDist` px, or -1 when none is close enough. */
export function nearestHub(point, hubPoints, maxDist) {
  let best = -1;
  let bestD = maxDist;
  hubPoints.forEach((h, i) => {
    const d = Math.hypot(h.x - point.x, h.y - point.y);
    if (d <= bestD) { bestD = d; best = i; }
  });
  return best;
}

/**
 * Which plan a press at `point` grabs by its hub end (within `radius` px), or
 * null. Several plans usually share a hub, so the selected plan wins, then
 * one with a predicted conflict, then the soonest to launch.
 */
export function pickDragPlan(plans, point, endPx, radius, selectedId = null) {
  const near = plans.filter((p) => {
    const e = endPx(p);
    return Math.hypot(e.x - point.x, e.y - point.y) <= radius;
  });
  if (!near.length) return null;
  const selected = near.find((p) => p.id === selectedId);
  if (selected) return selected.id;
  near.sort((a, b) => (b.predicted && !b.grounded) - (a.predicted && !a.grounded)
    || a.departAt - b.departAt || a.id - b.id);
  return near[0].id;
}

/**
 * What releasing a dragged route does: reroute via the hub it was dropped on,
 * or cancel when it's dropped away from a hub or back on the plan's own hub.
 */
export function resolveDrop(plan, hubIdx) {
  return hubIdx >= 0 && hubIdx !== plan.hubIdx ? { commit: true, hubIdx } : { commit: false, hubIdx: -1 };
}
